import * as actionTypes from './_actionTypes';
// import axiosInstance from '../../services/axios/axios';
// import { WrapImsPacket } from '../utility';

export const addBulkSelection = payload => {
	return {
		type: actionTypes.ADD_BULK_SELECTION,
		selection: payload.payload,
	};
};

export const removeBulkSelection = payload => {
	return {
		type: actionTypes.REMOVE_BULK_SELECTION,
		selection: payload.payload,
	};
};
export const resetBulkSelection = payload => {
	return {
		type: actionTypes.RESET_BULK_SELECTION,
	};
};

export const setAdalProfile = payload => {
	return {
		type: actionTypes.SET_PROFILE,
		profile: payload.payload,
	};
};

export const setImpersonator = payload => {
	return {
		type: actionTypes.SET_IMPERSONATOR,
		impersonator: payload.payload,
	};
};

export const setLoggedInUser = payload => {
	return {
		type: actionTypes.SET_LOGGED_IN_USER,
		user: payload.payload,
	};
};

export const updateNavigation = payload => {
	return {
		type: actionTypes.UPDATE_NAVIGATION,
		nav: payload.payload,
	};
};

/**
 * UAR Action Cart Creators
 */
export const setActionCartItems = items => {
	return {
		type: actionTypes.SET_ACTION_CART_ITEMS,
		items,
	};
};

export const addCartAction = item => {
	return {
		type: actionTypes.ADD_CART_ACTION,
		item,
	};
};

export const removeCartAction = itemKey => {
	return {
		type: actionTypes.REMOVE_CART_ACTION,
		itemKey,
	};
};

export const clearActionCart = () => {
	return {
		type: actionTypes.CLEAR_ACTION_CART,
	};
};

/**
 * UAR Modify Queue Creators
 */
export const setModifyQueue = items => {
	return {
		type: actionTypes.SET_MODIFY_QUEUE,
		items,
	};
};

export const advanceQueue = () => {
	return {
		type: actionTypes.ADVANCE_QUEUE,
	};
};

export const resetQueue = () => {
	return {
		type: actionTypes.RESET_QUEUE,
	};
};

/**
 * UAR Processed Requests Creators
 */
export const setProcessedRequests = items => {
	return {
		type: actionTypes.SET_PROCESSED_REQUESTS,
		items,
	};
};

export const clearProcessedRequests = () => {
	return {
		type: actionTypes.CLEAR_PROCESSED_REQUESTS,
	};
};
